import React, { Component } from 'react'


export class CommissionTotals extends Component<any, any> {

    componentDidUpdate(prevProps: Readonly<any>, prevState: Readonly<any>, snapshot?: any): void {
        if (Object.keys(prevProps.totals).length === 0 && Object.keys(this.props.totals).length !== 0) {
            this.forceUpdate()
        }
    }


    line = ({ credit = 0, debt = 0, balance = 0 }) => {
        return (
            <div style={{ ...style.lineValues }}>
                <div style={{ width: '32%' }}>
                    {this.unit({ title: 'זיכוי', value: credit })}
                </div>
                <div style={{ width: '32%' }}>
                    {this.unit({ title: 'חיוב', value: debt })}
                </div>
                <div style={{ width: '32%' }}>
                    {this.unit({ title: 'יתרה', value: balance })}
                </div>
            </div>
        )
    }


    unit = ({title, value}) => {
        const color =
                title === "זיכוי" ?
                "green" :
                title === "חיוב" ?
                "red" :
                value > 0 ?
                "green" :
                "red"

        return (
            <div style={{ ...style.unit }}>
                <span style={{ fontWeight: '600' }}>{title}</span>
                <span style={{ fontWeight:'normal', marginRight: '10px', color: color }}>{typeof value === 'number' && value !== null ? value.toFixed(1) : 0.0}</span>
            </div>
        )
    }


    render() {
        const { totals } = this.props

        let keys = Object.keys(totals)

        if (keys.includes('credit')) {
            return (
                <div style={{ width: '500px', fontSize: '14px', float: 'left' }}>
                    {this.line(totals)}
                </div>
            )
        } else if (keys.includes('general')) {
            return (
                <div style={{ width: '500px', fontSize: '14px', float: 'left' }}>
                    <div style={{ ...style.line }}>
                        <span>עמלות אישיות:</span>
                        {this.line(totals.general)}
                    </div>
                    <div style={{ ...style.line }}>
                        <span>עמלות סוכני משנה:</span>
                        {this.line(totals.subAgents)}
                    </div>
                    <hr style={{ margin: '2px 0 1px 0' }}/>
                    <div style={{ ...style.line }}>
                        <span>סה״כ:</span>
                        {this.line(totals.total)}
                    </div>
                </div>
            )
        } else {
            return null
        }
    }
}


const style = {

    line: {
        display: 'flex',
        justifyContent: 'space-between',
        width: '100%'
    },

    lineValues: {
        display: 'flex',
        width: '70%'
    },

    unit: {
        marginInline: '20px'
    }
}



